<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
      <el-form-item label="学期" prop="termName">
        <el-input v-model="dataForm.termName" placeholder="学期名" disabled></el-input>
      </el-form-item>
      <el-form-item label="活动名称" prop="activityName">
        <el-input v-model="dataForm.activityName" placeholder="活动名称"></el-input>
      </el-form-item>
      <el-form-item label="活动等级" prop="levelName">
        <el-select v-model="dataForm.levelId" placeholder="活动等级">
          <el-option v-for="level in levelList" :value="level.id" :label="level.levelName" :key="level.id"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item prop="deptName" :label="$t('user.deptName')">
        <ren-dept-tree v-model="dataForm.deptId" :placeholder="$t('dept.title')" :dept-name.sync="dataForm.deptName"></ren-dept-tree>
      </el-form-item>
      <el-form-item label="活动形式" prop="activityTypeName">
        <el-select v-model="dataForm.activityTypeId" placeholder="活动类型">
          <el-option v-for="type in typeList" :value="type.id" :label="type.examineTypeName" :key="type.id"></el-option>
        </el-select>
      </el-form-item>
<!--      <el-form-item label="公开报名" label-width="100px" prop="isPublic">-->
<!--        <el-radio-group v-model="dataForm.isPublic">-->
<!--          <el-radio :label='0'>否</el-radio>-->
<!--          <el-radio :label='1'>是</el-radio>-->
<!--        </el-radio-group>-->
<!--      </el-form-item>-->
      <el-form-item label="活动时间">
        <div class="block">
          <el-date-picker
                  v-model="activityTimeForm.activityTime"
                  type="datetimerange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  align="right"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  @change="activityDateHandle()">
          </el-date-picker>
        </div>
      </el-form-item>
<!--      <el-form-item label="报名须知" prop="activityNotes">-->
<!--        <el-input v-model="dataForm.activityNotes" placeholder="活动报名须知"></el-input>-->
<!--      </el-form-item>-->
      <el-form-item label="负责教师" prop="activityTeachTeacher" v-if="!dataForm.id">
        <span style="padding-right:10px;" :key="g" v-for="g in this.teacherNameList">{{g}}</span>
        <el-button style="color: #0aa0bf" @click="getActivityTeacherList()">+添加教师</el-button>
      </el-form-item>
      <el-form-item v-if="!dataForm.id" label="参与年级" prop="openingObject"></el-form-item>
      <div>
      <el-table v-if="!dataForm.id" :data="grades" border style="width: 100%;" @selection-change="selectionChange">
        <el-table-column  type="selection" header-align="center" align="center" width="50"></el-table-column>
        <el-table-column prop="title" label="年级" header-align="center" align="center"></el-table-column>
        <el-table-column prop="title" label="默认全部班级" header-align="center" align="center">
          <template slot-scope="scope">
            <el-button v-if="$hasPermission('grade:grade:update')" type="text" size="small" @click="activityEvaluateClassConfigHandle(scope)">班级设置</el-button>
          </template>
        </el-table-column>
      </el-table>
      </div>
<!--      <el-form-item label="预选学生" prop="activityStudent">-->
<!--        <span style="padding-right:10px;" :key="g" v-for="g in this.studentNameList">{{g}}</span>-->
<!--        <el-button style="color: #0aa0bf" @click="getActivityStudentList()">+预选学生</el-button>-->
<!--      </el-form-item>-->
      <el-form-item label="班级人数" prop="classNumberLimit">
        <el-input-number v-model="dataForm.classNumberLimit" :precision="0" :step="1" :min="0"/>设置为0则人数不限制
      </el-form-item>
<!--      <el-form-item label="活动地址" prop="activityAddress">-->
<!--        <el-input v-model="dataForm.activityAddress" placeholder="活动地址"></el-input>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="活动人数" prop="activityNumberLimit">-->
<!--        <el-input-number v-model="dataForm.activityNumberLimit" :precision="0" :step="1" :min="1"/>-->
<!--      </el-form-item>-->
<!--      <el-form-item label="报名时间" prop="notesStartTime">-->
<!--        <div class="block">-->
<!--          <el-date-picker-->
<!--                  v-model="activityTimeForm.notesTime"-->
<!--                  type="datetimerange"-->
<!--                  range-separator="至"-->
<!--                  start-placeholder="开始日期"-->
<!--                  end-placeholder="结束日期"-->
<!--                  align="right"-->
<!--                  value-format="yyyy-MM-dd HH:mm:ss"-->
<!--                  @change="noteDateHandle()">-->
<!--          </el-date-picker>-->
<!--        </div>-->
<!--      </el-form-item>-->
      <el-form-item label="活动简介" prop="activityIntroduction">
        <el-input v-model="dataForm.activityIntroduction" placeholder="活动简介"></el-input>
      </el-form-item>
      <el-form-item label="活动封面图" prop="activityImg">
        <el-upload
                class="avatar-uploader"
                :action="uploadUrl"
                :show-file-list="false"
                :on-success="uploadSuccessHandle"
                :before-upload="uploadBeforeUploadHandle">
          <img v-if="dataForm.activityImg" :src="dataForm.activityImg" class="avatar">
          <i v-else class="el-icon-plus avatar-uploader-icon"></i>
        </el-upload>
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
    <!-- 活动教师配置 -->
    <choose-activity-teacher v-if="chooseActivityTeacherVisible" ref="chooseActivityTeacher" v-on:checkedTeachers="checkedTeachers"></choose-activity-teacher>
    <!-- 预设学生 -->
    <choose-activity-student v-if="chooseActivityStudentVisible" ref="chooseActivityStudent" v-on:checkedStudent="checkedStudent"></choose-activity-student>
    <!-- 活动班级配置 -->
    <activity-evaluate-class-config v-if="activityEvaluateClassConfigVisible" ref="activityEvaluateClassConfig"></activity-evaluate-class-config>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
import ChooseActivityTeacher from './choose-activity-teacher'
import ChooseActivityStudent from './activityevaluaterule'
import ActivityEvaluateClassConfig from './activity-evaluate-class-config'
import Cookies from 'js-cookie'
export default {
  data () {
    return {
      uploadUrl: '',
      visible: false,
      chooseActivityTeacherVisible: false,
      chooseActivityStudentVisible: false,
      activityEvaluateClassConfigVisible: false,
      teacherNameList: [],
      studentNameList: [],
      grades: [],
      dataForm: {
        id: '',
        activityName: '',
        termId: '',
        termName: '',
        levelId: '',
        levelName: '',
        activityTypeId: '',
        activityTypeName: '',
        isPublic: '',
        activityStartTime: '',
        activityEndTime: '',
        activityIntroduction: '',
        activityNotes: '',
        activityAddress: '',
        activityNumberLimit: '',
        classNumberLimit: '',
        notesStartTime: '',
        notesEndTime: '',
        activityImg: '',
        openingObjectGroup: [],
        teacherList: [],
        teacherNameList: [],
        studentList: [],
        studentNameList: []
      },
      activityTimeForm: {
        activityTime: [],
        notesTime: []
      },
      currentTerm: '',
      typeList: [],
      levelList: []
    }
  },
  computed: {
    dataRule () {
      return {
        activityName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activityStartTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activityEndTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        notesStartTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        notesEndTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        levelName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        activityTypeName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        deptName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    init () {
      this.visible = true
      this.uploadUrl = `${window.SITE_CONFIG.apiURL}/sys/oss/upload?token=${Cookies.get('token')}`
      this.getCurrentTerm()
      this.getClassLevelList()
      this.getActivityList()
      this.getGradeList()
      this.defaultExamClass()
      this.$nextTick(() => {
        this.$refs.dataForm.resetFields()
        this.dataForm.teacherList = []
        this.teacherNameList = []
        this.studentNameList = []
        this.dataForm.studentList = []
        this.activityTimeForm.activityTime = []
        this.activityTimeForm.notesTime = []
        this.dataForm.openingObjectGroup = []
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    activityEvaluateClassConfigHandle (scope) {
      this.activityEvaluateClassConfigVisible = true
      this.$nextTick(() => {
        this.$refs.activityEvaluateClassConfig.dataForm.gradeId = scope.row.id
        this.$refs.activityEvaluateClassConfig.init()
      })
    },
    selectionChange (val) {
      this.multipleTable = val
    },
    // 获取信息
    getInfo () {
      this.$http.get('/activityEvaluate/activityEvaluate/' + this.dataForm.id).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
        console.log(this.dataForm.activityStartTime)
        this.activityTimeForm.activityTime.push(this.dataForm.activityStartTime)
        this.activityTimeForm.activityTime.push(this.dataForm.activityEndTime)
        this.activityTimeForm.notesTime.push(this.dataForm.notesStartTime)
        this.activityTimeForm.notesTime.push(this.dataForm.notesEndTime)
        this.teacherNameList = this.dataForm.teacherNameList
        this.studentNameList = this.dataForm.studentNameList
        console.log(this.activityTimeForm)
      }).catch(() => {})
    },
    // 获取年段列表
    getGradeList () {
      this.$http.get('grade/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.grades = res.data
      })
    },
    // 获取当前学年
    getCurrentTerm () {
      this.$http.get('/term/term/getCurrentTerm').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.currentTerm = res.data
        this.dataForm.termId = res.data.id
        this.dataForm.termName = res.data.termName
        this.dataForm.schoolId = res.data.schoolId
      }).catch(() => {})
    },
    // 获取教师列表
    getActivityTeacherList () {
      this.chooseActivityTeacherVisible = true
      this.$nextTick(() => {
        this.$refs.chooseActivityTeacher.init()
      })
    },
    // 获取学生列表
    // getActivityStudentList () {
    //   if (this.dataForm.openingObjectGroup.length === 0) {
    //     this.$message.error('请先选择参与年级')
    //     return
    //   }
    //   this.chooseActivityStudentVisible = true
    //   this.$nextTick(() => {
    //     this.$refs.chooseActivityStudent.init(this.dataForm.openingObjectGroup)
    //   })
    // },
    // 选中的教师
    checkedTeachers (val) {
      this.dataForm.teacherList = val[0]
      this.teacherNameList = val[1]
    },
    // 选中的学生
    checkedStudent (val) {
      this.dataForm.studentList = val[0]
      this.studentNameList = val[1]
    },
    // 获取活动等级
    getClassLevelList () {
      this.$http.get('/activityEvaluate/activityRank/getList', { params: { activityLevelParticipantRange: 1 } }).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.levelList = res.data
      }).catch(() => {})
    },
    // 获取活动类型
    getActivityList () {
      this.$http.get('/activityEvaluate/activityExamineType/getList').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.typeList = res.data
      }).catch(() => {})
    },
    // 处理活动开始时间
    activityDateHandle () {
      this.dataForm.activityStartTime = this.activityTimeForm.activityTime[0]
      this.dataForm.activityEndTime = this.activityTimeForm.activityTime[1]
    },
    // 处理报名时间
    noteDateHandle () {
      this.dataForm.notesStartTime = this.activityTimeForm.notesTime[0]
      this.dataForm.notesEndTime = this.activityTimeForm.notesTime[1]
      console.log(this.dataForm)
    },
    // 上传图片之前
    uploadBeforeUploadHandle (file) {
      if (file.type !== 'image/jpg' && file.type !== 'image/jpeg' && file.type !== 'image/png' && file.type !== 'image/gif') {
        this.$message.error(this.$t('upload.tip', { format: 'jpg、png、gif' }))
        return false
      }
    },
    // 上传图片成功
    uploadSuccessHandle (res, file, fileList) {
      if (res.code !== 0) {
        return this.$message.error(res.msg)
      }
      this.dataForm.activityImg = res.data.src
      console.log(this.dataForm.activityImg)
    },
    defaultExamClass () {
      this.$http.get('exam/exam/defaultExamClass').then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
      })
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.dataForm.activityTypeName = this.typeList.filter((e) => { return e.id === this.dataForm.activityTypeId })[0].examineTypeName
      this.dataForm.levelName = this.levelList.filter((e) => { return e.id === this.dataForm.levelId })[0].levelName
      this.$refs.dataForm.validate((valid) => {
        if (!valid) {
          return false
        }
        console.log(this.multipleTable)
        if (this.multipleTable !== undefined) {
          const gradeIds = this.multipleTable.map(t => t.id)
          this.dataForm.openingObjectGroup = gradeIds
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/activityEvaluate/activityEvaluate/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { leading: true, trailing: false })
  },
  components: {
    ChooseActivityTeacher,
    ChooseActivityStudent,
    ActivityEvaluateClassConfig
  }
}
</script>
